import React from 'react';

import { ErrorCard } from '../../../../../components/ErrorCard';
import { PageHeader } from '../../../../../components/PageHeader';

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry }) => {
  return (
    <div className="p-6 min-h-screen bg-background">
      <PageHeader
        title="Supplier Details"
        description="View and edit supplier information"
      />
      <div className="mt-6">
        <ErrorCard
          title="Error loading supplier"
          message={message || 'Supplier not found'}
          onRetry={onRetry}
        />
      </div>
    </div>
  );
};
